import * as Tone from "tone"
import { mapValue } from "../../common/utils";
import { featuresContext } from "../features";

const { noise } = featuresContext

const autoPanner = new Tone.AutoPanner({
  frequency: "1m",
  depth: 1,
  wet: 0.7,
})
// Noise
const noiseReverb = new Tone.Reverb({
  decay: 2,
  wet: 0.8,
});
const noiseTremolo = new Tone.Tremolo("1m", 0.1);
const noiseVolume = mapValue(noise, 0, 0.5, -20, -3);
const brownNoise = new Tone.Noise({
  fadeIn: 2,
  fadeOut: 2,
  type: "brown",
  volume: noiseVolume,
});
const noiseLFO = new Tone.LFO("4m", 1000, 8000)

const noiseFilter = new Tone.Filter(1000, "highpass", "-12");

noiseLFO.connect(noiseFilter.frequency);

const noiseGain = new Tone.Gain().toDestination();

brownNoise
  .chain(
    noiseReverb,
    noiseFilter,
    noiseTremolo,
    autoPanner,
    noiseGain,
    Tone.Destination
  )

const noiseLoop = new Tone.Loop((time) => {
  brownNoise.start(time).stop(`+${Tone.Time('4n')}`)
}, '4n')

export const startNoise = () => {
  autoPanner.start()
  noiseLFO.start()
  noiseLoop.start()
}

export const stopNoise = () => {
  autoPanner.stop()
  noiseLFO.stop()
  noiseLoop.stop()
  brownNoise.stop();
}